import { FETCH_CONTENT_ASSISTANT_SETTINGS_PENDING, FETCH_CONTENT_ASSISTANT_SETTINGS_SUCCESS, FETCH_CONTENT_ASSISTANT_SETTINGS_ERROR } from '../actions/ActionTypes';
const initialState = {
  contentAssistanceEnabled: null,
  isRequesting: false
};
export const contentAssistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENT_ASSISTANT_SETTINGS_PENDING:
      return Object.assign({}, state, {
        isRequesting: true
      });
    case FETCH_CONTENT_ASSISTANT_SETTINGS_SUCCESS:
    case FETCH_CONTENT_ASSISTANT_SETTINGS_ERROR:
      return Object.assign({}, state, {
        isRequesting: false,
        contentAssistanceEnabled: action.payload.contentAssistanceEnabled
      });
    default:
      return state;
  }
};
export default contentAssistantReducer;